// extracted by mini-css-extract-plugin
module.exports = {"card":"LittleCard_card__RYrfI"};